import React from 'react';
import withDefaults from '../utils/with-defaults'

interface Props {
    className?: string
}

const defaultProps = {
    className: '',
}

type NativeAttrs = Omit<React.HTMLAttributes<any>, keyof Props>
export type BreadcrumbsProps = Props & typeof defaultProps & NativeAttrs


const StepsSeparator: React.FC<BreadcrumbsProps> = ({
    className,
}) => {
    return (
        <div className={`${className} h-3 w-3 mx-3 text-gray-650`}>
            <svg className="h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
        </div>
    )
}

const MemoStepsSeparator = React.memo(StepsSeparator)

export default withDefaults(MemoStepsSeparator, defaultProps)